module.exports = __webpack_public_path__ + "static/media/4.dfc9c85b.png";